import { Pipe, PipeTransform } from '@angular/core';
import { RoleViewModel } from 'src/app/shared/models/autogenerated-piping';

/** Filters a RoleViewModel list to internal (2) and external (3) reviewers only,
 *  deduplicates by userId (internal wins when a user appears on both lists),
 *  and sorts internal before external then alphabetically by display name. */
@Pipe({
    name: 'reviewerFilter',
    standalone: false
})
export class ReviewerFilterPipe implements PipeTransform {
    transform(members: RoleViewModel[]): RoleViewModel[] {
        if (!members) { return []; }

        // Keep only reviewer roles, sort internal (2) before external (3) so internal wins deduplication
        const sorted = [...members]
            .filter(m => m.userRole === 2 || m.userRole === 3)
            .sort((a, b) => (a.userRole ?? 9) - (b.userRole ?? 9));

        // Deduplicate: first occurrence per userId wins (internal, due to sort above)
        const seen = new Set<string>();
        const unique = sorted.filter(m => {
            const key = m.userId ?? m.userEmail ?? '';
            if (seen.has(key)) { return false; }
            seen.add(key);
            return true;
        });

        // Final sort: internal first, then alphabetical by display name
        return unique.sort((a, b) => {
            if (a.userRole !== b.userRole) {
                return (a.userRole ?? 9) - (b.userRole ?? 9);
            }
            const nameA = (a.userDisplayName ?? a.userEmail ?? '').toLowerCase();
            const nameB = (b.userDisplayName ?? b.userEmail ?? '').toLowerCase();
            return nameA.localeCompare(nameB);
        });
    }
}
